import React from 'react';

export default ({ className }) => (
  <span className={className}>
    <svg x="0px" y="0px" viewBox="0 0 51.3 52">
<g>
	<path d="M37.4,1.1H13.9c-7,0-12.6,5.7-12.6,12.6v24.6c0,7,5.7,12.6,12.6,12.6h23.6c7,0,12.6-5.7,12.6-12.6V13.7
		C50.1,6.7,44.4,1.1,37.4,1.1z M46.7,13.7v24.6c0,5.1-4.1,9.2-9.2,9.2H13.9c-5.1,0-9.2-4.1-9.2-9.2V13.7c0-5.1,4.1-9.2,9.2-9.2h23.6
		C42.5,4.5,46.7,8.6,46.7,13.7z"/>
	<path d="M25.6,14.1c-6.5,0-11.9,5.3-11.9,11.9s5.3,11.9,11.9,11.9S37.5,32.5,37.5,26S32.2,14.1,25.6,14.1z M32.9,26
		c0,4-3.3,7.3-7.3,7.3S18.4,30,18.4,26c0-4,3.3-7.3,7.3-7.3S32.9,22,32.9,26z"/>
	<path d="M37.8,10.3c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6c2,0,3.6-1.6,3.6-3.6C41.3,11.9,39.8,10.3,37.8,10.3z"/>
</g>
</svg>
  </span>
)